import { createSelector } from '@reduxjs/toolkit'
import { RootState } from "@/store/store";

const rootSelector = (state: RootState) => state.profile;

export const profileSelector = rootSelector
export const userSelector = createSelector([rootSelector], (profile) => profile.user)
export const profileTodosSelector = createSelector([rootSelector], (profile) => profile.todos)
export const profileGrandidSelector = createSelector([rootSelector], (profile) => profile.grandid)
